/* eslint-disable react/prop-types */
import React from 'react';
import { Fragment } from 'react';

import { createGlobalStyle } from 'styled-components';

export default function Primary() {
  // const [wrap, setWrap] = React.useState(null);

  React.useEffect(() => {
    const btnPrint = document.querySelector('#btn-print');
    btnPrint.addEventListener('click', function () {
      window.print();
    });

    const products = JSON.parse(localStorage.getItem('@products'));
    if (!products) return false;
    const root = document.getElementById('root');
    root.style.backgroundColor = 'rgb(82, 86, 89)';
    let wrap = document.querySelector('.wrap');
    async function delay(item) {
        console.log(item)
      const wait = new Promise((resolve) => {
        setTimeout(function () {
          const html = `
                    <div class='container-print'>
                        <div class='leftimage'><figure class='logo'><img src='/images/leftimage.png'/></figure></div>
                        <div class='righimage'><figure class='logo'><img src='/images/leftimage2.png'/></figure></div>
                        <div class='content'>
                            <div class='tab_header'><figure class='logo'><img src='/images/logonew.png'/></figure></div>                            
                            <div class='tab_main tab1'> 
                                <p class='textavista'>DE</p>                                                         
                                <div class='panel avista'>                              
                                    <div class='panel__description'>                                        
                                        <div class='col2'>${item.psistema.split(',')[0]}<sup class='avista'>,99</sup></div>  
                                        <p class='cifrao'>R$</p>
                                    </div>                                                                    
                                </div>
                            </div>
                            <div class='tab_main tab2'> 
                                <p class='textavista'>POR</p>                                                         
                                <div class='panel avista'>                              
                                    <div class='panel__description'>                                        
                                        <div class='col2'>${item.avista.split(',')[0]}<sup class='avista'>,99</sup></div> 
                                         <p class='cifrao'>R$</p> 
                                    </div>                                                                    
                                </div>
                            </div>
                          

                          </div>
                          
                          <div class='tab_footer'>
                            <div class='panel__info'>
                            <p class='ref'>REF: ${item.codigo} / ${item.padrao}</p>
                            <p class='name'>${item.nome}</p>
                            </div>
                            <figure class='prazo'>
                              <img src=''/>
                            </figure>
                          </div>
                      </div>
                    </div>`;
          wrap.innerHTML += html.trim();
          resolve();
        }, 200);
      });

      return await wait;
    }

    async function processArraySequence(array) {
      let n = 1;
      let count = 1;
      //console.log(array)
      for (const item of array) {
        await delay(item);
        if (array.length === count) return false;
        if (n === 4) {
          wrap = create();
          n = 0;
        }
        n++;
        count++;
      }
    }

    function create() {
      const wrapAll = document.querySelectorAll('.wrap');
      wrap = wrapAll[wrapAll.length - 1].cloneNode(true);
      wrap.classList.remove('first');
      wrap.innerHTML = "<div class='guia'><div class='guiaY'></div><div class='guiaX'></div></div>";
      root.appendChild(wrap);
      return wrap;
    }

    processArraySequence(products);
  }, []);

  return (
    <Fragment>
      <GlobalStyle />
      <FixedHeader className="fixed-header print" />
      <Wrap className="wrap first" />
    </Fragment>
  );
}

const FixedHeader = ({ className, children }) => (
  <div className={className}>
    <div className="fixed-title">
      <h6>TABELA PRIMÁRIA 2X4</h6>
    </div>
    <div className="buttons">
      <a href="/tabelas30">
        <img src="/images/buttons/button-mini-back.svg" alt="Boltão voltar" />
      </a>
      <button id="btn-print">
        <img src="/images/buttons/button-mini-print.svg" alt="Boltão voltar" />
      </button>
    </div>
    {children}
  </div>
);

const Wrap = ({ className, children }) => (
  <Fragment>
    <div className={className}>
      <div className="guia">
        <div className="guiaY"></div>
        <div className="guiaX"></div>
      </div>
    </div>
    {children}
  </Fragment>
);
// background-color: rgb(82, 86, 89) !important;
const GlobalStyle = createGlobalStyle`
* {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
}

body {
    font-family: Helvetica, Arial, sans-serif;    
}

img {
    display: block;
    width: 100%;
}

.back {
    background-color: #fff;
    padding: 5px 20px;
    border-radius: 5px;
    text-decoration: none;
    margin-left: 10px;
    font-size: 10pt;
    transform: translate(-35px,-1px);
}
.fixed-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 15mm;
    background-color: rgb(50, 54, 57);
    box-shadow: 1px 1px 5px #000;
    color: #fff;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    z-index: 10000;
}
.buttons {
    display: flex;
    align-items: center;
}

.fixed-header button {
    transform: all;
    background-color: transparent;
    box-shadow: none;
    border: none
}

.fixed-header button img {
    width: 35px;
}

.fixed-header button img:hover {
    transform-origin: center;
    transform: scale(1.1);
    cursor: pointer;
    transition: all .2s;
}

.buttons a {
    margin: 5px;
}
.buttons a img{
    width: 35px;
}

.fixed-header .wrap-center {
    width: 210mm;
    margin: 0 auto;
}

.wrap{
    position: relative;
    margin: 0 auto;
    width: 210mm;
    height: 297mm;    
    background-color: #fff;
    margin-bottom: 5mm;
}

.wrap.first {
    margin-top: 17mm;
}

.guia {
    position: absolute !important;

    top: 0;
    left: 0;

    width: 100% !important;
    height: 100% !important;

    display: block !important;

    z-index: 100 !important;

    /* não interfere nos cards */
    pointer-events: none;
}

/* LINHA HORIZONTAL */
.guia .guiaY {
    position: absolute !important;

    top: 50% !important;
    left: 0 !important;

    width: 100% !important;
    height: 1px !important;

    background-color: rgb(192, 192, 192) !important;

    transform: translateY(-50%);

    display: block !important;

    z-index: 101 !important;
}

/* LINHA VERTICAL */
.guia .guiaX {
    position: absolute !important;

    top: 0 !important;
    left: 50% !important;

    width: 1px !important;
    height: 100% !important;

    background-color: rgb(192, 192, 192) !important;

    transform: translateX(-50%);

    display: block !important;

    z-index: 101 !important;
}

.container-print {
    background-color: #ffffff;
    position: relative;
    width: calc((210mm - 61px) / 2);
    height: calc((100% - 61px) / 2);
    /* background-color: red; */
    z-index: 1;
    margin: 15px;   
    display: flex;
    float: left;
    padding: 10px !important;
}

.leftimage{
    position: absolute;
    width: 30%;
    right: 10px;
    top: 100px;
    z-index: 1;
}

.righimage{
    position: absolute;
    width: 20%;
    left: 10px;
    top: 350px;
    z-index: 1;
}

.content {
    position: relative;
    width: 355px;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    border: 3px solid #000051;
    border-radius: 10px;
    flex-direction: column;
}

.tab_header {
    margin-top: -40px;
    margin-bottom: 30px;
}

p.avista {
    display: flex;   
    width: 100%;
    padding: 0 15px;
    font-size: 18px;
    font-size: 15pt;
    font-family: "Roboto",sans-serif;    
    font-weight: bolder;
    color: #000051;
    margin: 20px 0 0 10px;
    padding: 5px 20px;
}


.tab_header .logo {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 0px 10px;
}

.tab_header img {
    width: 90%;
    margin-top: 10px;
}

.tab_main {       
    position: relative;
    width: 92%;
    margin: 0 10px;
    padding: 20px;
    border: 4px solid #710000;
    border-radius: 15px;    
    font-family: "Roboto",sans-serif;   
    font-weight: bolder;
    color: #000051;
    z-index: 2;    
    margin-bottom: 30px;
}

.panel.avista {
    margin-left: 40px;
}

.textavista {
    position: absolute;
    font-family: inherit;
    top: 3px;
    left: 10px;
    width: 100%;
    font-size: 24px;
    color: #000051;  
    font-family: "Roboto",sans-serif;
}

.cifrao {
    position: absolute;
    font-size: 32px;
    top: 55px;
    left: 20px;
}

.semjuros {
    position: absolute;
    bottom: 3px;
    left: 33px;
}

.tab_main.tab3 {
   height: 110px;
}

.tab_footer {
    position: absolute;
    width: 100%;
    padding: 0 15px;
    bottom: 25px;
    left: 15px;
}

@media only screen and (max-width: 37.5em) {  
    .wrap {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        height: 100%;
    }

    .container-print {
        display: flex;
        margin: 0 auto;
        float: none;
    }

    .content {
        transform: scale(1);
        padding: 5rem 0;
    }

    .tab_header img {
        width: 70%;
        transform: translateY(-30%);
    }

    .tab_main {
        margin-bottom: 20px;
    }

    .guia .guiaY,
    .guia .guiaX {
        display: none;
    }
}

.tab_footer .prazo {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
}

.panel.avista {
    
}

.panel__info {
    font-family: "Roboto", sans-serif;
    font-size: 10pt;    
    font-weight: bolder;
    margin-bottom: 20px;
    color: #000051;
}

.panel__info .name {
    
}

.panel__description {
    flex: 1;
    display: flex;
    align-items: center;
    font-family: Impact, 'Courier New', Courier, monospace,Haettenschweiler, 'Arial Narrow Bold', sans-serif;
    
}

.panel__description .col0 {
    display: flex;
    flex-direction: column;    
    color: #000051;    
    width: 20%;
}

.panel__description .col0 .cifrao.first {
    text-align: right;
    font-size: 23pt;
    margin-top: 30px;
}

.panel__description .col1 {
    display: flex;
    flex-direction: column;
    padding-right: 2mm;
    color: #000051;
    width: 32%;
}


.panel__description .col1 .plano {
    font-size: 30pt;
    color: #710000;
    border: 4px solid #000051;
    border-radius: 2mm;
    padding: 0 2mm;
}

.panel__description .col1 .cifrao {
    text-align: right;
    font-size: 15pt;
}

.panel__description .col2 {
    flex: 1;
    font-size: 55pt;
    display: flex;
    justify-content: center;
    line-height: 1;
    color: #000051;
}

.col2.price {
    font-size: 55pt;
    margin-top: 10px;
}

.panel__description .col2 sup.avista {
    font-family: Impact, 'Courier New', Courier, monospace,Haettenschweiler, 'Arial Narrow Bold', sans-serif;
    margin: 0;
    margin-top: -8px;
    margin-left: 5px;    
    font-size: 35pt;
}

.panel__description .col2 sup {
    margin-top: -7px;
    font-family: Impact, 'Courier New', Courier, monospace,Haettenschweiler, 'Arial Narrow Bold', sans-serif;
    height: 20mm;
    font-size: 40pt;
    transform: translateY(3mm);       
}

.panel__footer {
    color: #000051;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 15pt;
    font-family: "Roboto", sans-serif;    
    font-weight: bolder;
}

@page :left {
    margin: 1mm;
}

@page :right {
    margin: 1mm;
}

@page {
    size: A4 portrait;
    margin: 0;
}

@media print {

    html,
    body,
    #root {
        margin: 0 !important;
        padding: 0 !important;

        background: #fff !important;
        background-color: #fff !important;
    }

    .fixed-header.print {
        display: none !important;
    }

    .wrap {
        position: relative !important;

        width: 210mm !important;
        height: 297mm !important;

        margin: 0 !important;
        padding: 14px !important;

        background: #fff !important;
        background-color: #fff !important;

        display: grid !important;

        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(2, 1fr);

        column-gap: 20px;
        row-gap: 20px;

        box-sizing: border-box !important;

        break-after: page !important;
        page-break-after: always !important;

        break-inside: avoid !important;
        page-break-inside: avoid !important;

        overflow: hidden !important;
    }

    .wrap:last-of-type {
        break-after: auto !important;
        page-break-after: auto !important;
    }

    .container-print {
        position: relative !important;

        width: 100% !important;
        height: 100% !important;

        min-width: 0 !important;
        min-height: 0 !important;

        padding: 0 !important;
        margin: 0 !important;

        display: flex !important;
        float: none !important;

        background: #fff !important;

        box-sizing: border-box !important;

        break-inside: avoid !important;
        page-break-inside: avoid !important;

        z-index: 1 !important;
    }

    /* GUIAS SEMPRE POR CIMA */
    .guia {
        position: absolute !important;

        top: 0 !important;
        left: 0 !important;

        width: 100% !important;
        height: 100% !important;

        display: block !important;

        z-index: 100 !important;

        pointer-events: none;
    }

    .guia .guiaY {
        position: absolute !important;

        top: 50% !important;
        left: 0 !important;

        width: 100% !important;
        height: 1px !important;

        background: rgb(192, 192, 192) !important;

        transform: translateY(-50%);

        display: block !important;
    }

    .guia .guiaX {
        position: absolute !important;

        top: 0 !important;
        left: 50% !important;

        width: 1px !important;
        height: 100% !important;

        background: rgb(192, 192, 192) !important;

        transform: translateX(-50%);

        display: block !important;
    }
}
`;
